import type { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { rgba } from 'polished';

import { defaultThemeProp, tryCatch } from '@pega/cosmos-react-core';
import type { WithAttributes } from '@pega/cosmos-react-core';

const StyledCode = styled.code(
  ({ theme }) => css`
    color: ${theme.base.palette['foreground-color']};
    background-color: ${theme.base.palette['secondary-background']};
    border-radius: calc(${theme.base['border-radius']} * 0.5);
    box-shadow: inset 0 0 0 0.0625rem
      ${tryCatch(() => rgba(theme.base.palette['foreground-color'], 0.1))};

    & > span {
      padding-inline: calc(${theme.base.spacing} * 0.5);
      box-decoration-break: clone;
      -webkit-box-decoration-break: clone;
    }
  `
);

StyledCode.defaultProps = defaultThemeProp;

type CodeProps = WithAttributes<
  'code',
  {
    children: ReactNode;
  }
>;

const Code = ({ children, ...restProps }: CodeProps) => {
  return (
    <StyledCode {...restProps}>
      <span>{children}</span>
    </StyledCode>
  );
};

export default Code;
